import { render, staticRenderFns } from "./MedPlans.vue?vue&type=template&id=3412a2a8"
import script from "./MedPlans.vue?vue&type=script&lang=js"
export * from "./MedPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports